import { Bar } from "react-chartjs-2";
import ChartJSDataLabel from 'chartjs-plugin-datalabels'
import { Chart as ChartJS } from "chart.js/auto";
import { Chart as CJS } from "chart.js";

export const BarChart = ({ data, config }) => {
  CJS.register(ChartJSDataLabel)
  return (
    <Bar data={data} {...config} />
  );
};